// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"201":"cc46cc8b","224":"0361aa39","238":"0bfbc6f9","239":"d20a7e19","455":"81cd6283","633":"b4de4a25","749":"189e130d","777":"9b6a5fd3","903":"1f89c609","959":"7b9eabe2","977":"e96d1270"}[chunkId] + ".chunk.js";
};